<script lang="ts">
	import { Toggle, ToggleV2 } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { createEventDispatcher } from 'svelte';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let mail: boolean, push: boolean, notification: string, loading: boolean;

	const dispatch = createEventDispatcher();

	function changeNotificationSetting(notification: string, notifType: number) {
		dispatch('changeNotificationSetting', { notification, notifType });
	}

	$: ToggleC = $showNewLayout ? ToggleV2 : Toggle;
</script>

<svelte:component
	this={ToggleC}
	class={$showNewLayout ? 'mb-s' : ''}
	checked={mail}
	disabled={loading}
	size="m"
	on:click={() => changeNotificationSetting(notification, 0)}
	id="toggle-czek67u"
>
	{$showNewLayout
		? capFirstChar(
				$format('text_device_mail_notification_option_label', {
					values: {
						notification: $format(`text_device_${notification}_notification_option`, {
							default: notification,
						}),
					},
					default: '{notification} email notifications.',
				}),
			)
		: capFirstChar(
				$format('text_device_mail_notification_option', {
					values: {
						notification: $format(`text_device_${notification}_notification_option`),
					},
				}),
			)}
</svelte:component>
<svelte:component
	this={ToggleC}
	checked={push}
	disabled={loading}
	size="m"
	on:click={() => changeNotificationSetting(notification, 1)}
	id="toggle-xnsqn4m"
>
	{$showNewLayout
		? capFirstChar(
				$format('text_device_push_notification_option_label', {
					values: {
						notification: $format(`text_device_${notification}_notification_option`, {
							default: notification,
						}),
					},
					default: '{notification} push notifications.',
				}),
			)
		: capFirstChar(
				$format('text_device_push_notification_option', {
					values: {
						notification: $format(`text_device_${notification}_notification_option`),
					},
				}),
			)}
</svelte:component>
